import { IconRepeat } from '@tabler/icons-react'
import { Children, ReactNode, useEffect, useRef } from 'react'

import { AstraIcon, AstraParagraph, astraTwMerge } from '~/astra'

export const EmptyChat = () => (
    <div className="flex flex-col items-center gap-8 p-6">
        <span className="rounded-full bg-magic-strong-rest p-2">
            <AstraIcon icon={IconRepeat} color="text-white" />
        </span>
        <AstraParagraph className="max-w-[320px] text-center text-muted">Legg til ny regel</AstraParagraph>
    </div>
)

export const ChatEntryList = ({ children, autoScroll = true }: { children: ReactNode; autoScroll?: boolean }) => {
    /* Because of overflow the height on the container would not change, and thus we could not use
    ResizeObserver, so we split into two divs and observe the child height */
    const chatContainerRef = useRef<HTMLDivElement | null>(null)
    const scrollContainerRef = useRef<HTMLDivElement | null>(null)

    // automatically scroll to bottom when chat content changes height (eg. a new message is added)
    useEffect(() => {
        const resizeObserver = new ResizeObserver(() => {
            if (autoScroll) {
                scrollContainerRef.current?.scrollTo({ top: chatContainerRef.current?.scrollHeight, behavior: 'smooth' })
            }
        })
        if (autoScroll && chatContainerRef.current) {
            resizeObserver.observe(chatContainerRef.current)
        }
        return () => resizeObserver.disconnect()
    }, [autoScroll])

    const isEmpty = Children.toArray(children).filter(Boolean).length < 1

    return (
        <div ref={scrollContainerRef} className="h-[40vh] w-full overflow-auto">
            <div ref={chatContainerRef} className={astraTwMerge('flex flex-col gap-8 px-4 text-muted', isEmpty ? 'h-full justify-center' : '')}>
                {isEmpty && <EmptyChat />}
                {children}
            </div>
        </div>
    )
}
